import PropTypes from 'prop-types';

const preTitle = 'Linkpick | ';
// const URL = 'https://www.linkpick.fr/';

const Head = ({ subtitle, title }) => {
  const bigTitle = preTitle + title;
  if (subtitle === '') {
    // eslint-disable-next-line no-param-reassign
    subtitle =
      'Linkpick est la première solution qui aide et met en relation les étudiants, les entreprises et les écoles, avant, pendant et après la formation.';
  }
  return (
    <head>
      <meta charSet="utf-8" />
      <meta content="width=device-width, initial-scale=1" name="viewport" />
      <meta content="index" name="robots" />
      <meta content="follow" name="robots" />
      {/* classic meta  */}
      <title>{bigTitle}</title>
      <meta content={subtitle} name="description" />

      {/* Open Graph meta  */}
      <meta content={bigTitle} property="og:title" />
      <meta content={subtitle} property="og:description" />
      <meta content="Site_meta_media.png" property="og:image" />
      <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.9.3/html2pdf.bundle.min.js" integrity="sha512-YcsIPGdhPK4P/uRW6/sruonlYj+Q7UHWeKfTAkBW+g83NKM+jMJFJ4iAPfSnVp7BKD4dKMHmVSvICUbE/V1sSw==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>
      {/* <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js" integrity="sha512-GsLlZN/3F2ErC5ifS5QtgpiJtWd43JWSuIgh7mbzZ8zBps+dvLusV+eNQATqgA/HdeKFVgA5v3S/cIrLF7QnIg==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>
      <script src="html2pdf.bundle.min.js"></script> */}
    </head>
  );
};

Head.propTypes = {
  icon: PropTypes.element,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default Head;
